// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03c306e3","556":"60aecc3f","604":"cfd7dbdd","887":"2edf72e0","982":"23656b3b"}[chunkId] + ".chunk.js";
};